module.exports = __webpack_public_path__ + "img/2xko_01.ee759bae.jpg";